export default "__VITE_ASSET__22d16068__"